import React from 'react';
import { serviceService } from '../../services/serviceService';
import { getMediaUrl } from '../../services/api';

export default class ServiceFour extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      loading: true
    };
  }

  async componentDidMount() {
    try {
      const res = await serviceService.getServices();
      if (res.success && Array.isArray(res.data)) {
        this.setState({ services: res.data, loading: false });
      } else {
        this.fallbackServices();
      }
    } catch (err) {
      console.error('Failed to load services from database:', err);
      this.fallbackServices();
    }
  }

  fallbackServices() { this.setState({ services: [], loading: false }); }

  render() {
    const { services } = this.state;

    return (
      <>
        <section className="services-one-sec services-one-sec--services">
          <div className="container">
            <div className="sec-title text-center">
              <div className="sec-title__tagline">
                <span className="left"></span>
                <h6>Our Services</h6>
                <span className="right"></span>
              </div>
              <h2 className="sec-title__title">Our Professional Services</h2>
            </div>

            <div className="row align-items-stretch">
              {services.map((service, index) => {
                const imgUrl = getMediaUrl(service.image);

                return (
                  <div
                    key={service.id || index}
                    className="col-xl-4 col-lg-4 wow fadeInUp"
                    data-wow-delay={`${index * 100}ms`}
                    data-wow-duration="1500ms"
                    style={{ display: 'flex' }}
                  >
                    <div className="services-one__single" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                      <div
                        className="services-one__single-img"
                        style={{ height: '220px', overflow: 'hidden', flexShrink: 0 }}
                      >
                        <img
                          src={imgUrl}
                          alt={service.title || service.name}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>

                      <div className="services-one__single-content" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <div className="services-one__single-content-title">
                          <h2>{service.title || service.name}</h2>
                        </div>

                        <div className="services-one__single-content-bottom" style={{ flex: 1 }}>
                          <p>{service.description || service.shortDescription}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>{/* end row */}
          </div>{/* end container */}
        </section>
      </>
    );
  }
}
